import axios from 'axios';
import store from '@/store/index'
import { ToastProgrammatic as Toast } from 'buefy'
import {getDomain } from './backend'
import i18n from '@/i18n'
export default function setup() {
    // before any request
    axios.interceptors.request.use(config => {
        if (!config._silent && !store.getters.disableSite) {
            store.dispatch("lockSite");
        }
        //only add auth header to backend calls
        if(config.url.startsWith(getDomain())){
            const token = store.getters.token
            if (token != null && token.token) {
                let expiryDate = new Date(token.expiry)
                if (config.url && !config.url.includes('auth/connect/refresh')) {
                    expiryDate.setMinutes(expiryDate.getMinutes() - 10)
                }
                if (expiryDate < new Date()) {
                    store.dispatch('refreshToken')
                }
                if (store.getters.token.token) {
                    config.headers.Authorization = `Bearer ${store.getters.token.token}`
                }
    
            }
            if(store.getters.locale){
                config.headers["x-lang"] = store.getters.locale
            }
        }

        return config
    })


    function errorResponseHandler(error) {
        // if has response show the error
        const originalRequest = error.config;
        const isRetry = originalRequest._retry;
        if (!originalRequest._retry) {
            originalRequest._retry = true;
        }

        if (!isRetry && (!error.response || !error.response.status)) {
            Toast.open(i18n.t('errors.no-connection'));
            if (store.getters.disableSite) {
                store.dispatch("unlockSite");
            }
        }
        if (error.response) {
            if (error.response.data) {
                if (error.response.status == 410
                    && error.response.data.type == "https://touristik-vertrieb.at/invalid-order") {
                    //needs to reset local storage
                    store.dispatch("clearCart");
                    if (error.request && error.request.responseURL.includes('api/order/items')) {
                        //was add call, retry
                        return store.dispatch('addProduct', JSON.parse(error.config.data).variantId);
                    }
                }
                if (error.response.status == 401 && error.response.data.extensions.errorCode == 101) {
                    store.dispatch("showLogin");
                    // eslint-disable-next-line no-unused-vars
                    return new Promise((resolve,_reject) => {
                        const unsubscribe = store.subscribe(mutation => {
                            if (mutation.type == 'ACCESS_TOKEN_UPDATED') {
                                    error.config.headers.Authorization = `Bearer ${mutation.payload.token}`
                                    resolve(axios.request(error.config))
                                    unsubscribe();
    
                            }
                        })
                    })
                
                }
                if (error.response.status == 428 && error.response.data.extensions.errorCode == 115) {
                    store.dispatch("clearCart");
                }
            }
        }

        if (store.getters.disableSite) {
            store.dispatch("unlockSite");
        }
        return Promise.reject({ ...error })
    }


    // after any request
    axios.interceptors.response.use(response => {

        if (store.getters.disableSite) {
            store.dispatch("unlockSite");
        }
        return response
    },
        errorResponseHandler);
}